var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5349 8.86142C10.2874 7.95053 10.7626 6.78221 10.7626 5.49508C10.7626 2.60399 8.40619 0.247559 5.5151 0.247559C2.62401 0.247559 0.267578 2.60399 0.267578 5.49508C0.267578 8.38617 2.62401 10.7426 5.5151 10.7426C6.78243 10.7426 7.97055 10.2872 8.88144 9.51489L12.9606 13.5941C13.0597 13.6931 13.1785 13.7327 13.2973 13.7327C13.4161 13.7327 13.5349 13.6931 13.6339 13.5941C13.8121 13.4159 13.8121 13.099 13.6339 12.9208L9.5349 8.86142ZM5.4953 9.79211C3.11906 9.79211 1.19827 7.87132 1.19827 5.49508C1.19827 3.11885 3.11906 1.19805 5.4953 1.19805C7.87154 1.19805 9.79233 3.11885 9.79233 5.49508C9.79233 7.87132 7.87154 9.79211 5.4953 9.79211Z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.0d87fe509c114251b6dcdb6f698d7b06.svg";
export { ForwardRef as ReactComponent };